import { createContext, useEffect, useRef, useState } from 'react'
import useWindowSize from '../hooks/useWindowSize';
import useScrollDown from '../hooks/useScrollDown';
import news1 from '../assets/imgs/general/noticias/bailecmpv.jpg';
import news2 from '../assets/imgs/general/noticias/Comunicado-aos-socios.png';
import event1 from '../assets/imgs/general/torneiojudo.jpg';
import event2 from '../assets/imgs/general/bailefantasia.jpg';
import event3 from '../assets/imgs/general/premiacao.jpg';
import event4 from '../assets/imgs/general/domingodepascoa.jpg';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isScrollingDown, setIsScrollingDown] = useState(false);
    const [showSecondaryHeader, setShowSecondaryHeader] = useState(true);
    const [zoomLevel, setZoomLevel] = useState(1);
    const lastScrollYRef = useRef(0);
    const { width } = useWindowSize();
    const { scrollY } = useScrollDown();

    useEffect(() => {
        setIsMobile(width <= 1350);
    }, [width]);

    useEffect(() => {
        const prev = lastScrollYRef.current;
        if (scrollY > prev && scrollY >= 200) {
            setIsScrollingDown(true);
            setShowSecondaryHeader(false);
        } else if (scrollY < prev) {
            setIsScrollingDown(false);
            setShowSecondaryHeader(true);
        }
        lastScrollYRef.current = scrollY;
    }, [scrollY]);

    // ← useEffect do window.scrollTo removido daqui
    // O scroll para o topo é feito pelo ScrollToTop.jsx via pushState

    const newsInfos = [
        { id: 1, title: 'BAILE DE BOAS VINDAS ECEME E 68 ANOS DO CMPV', description: '03/04/2025', imageUrl: news1, info: 'Lorem ipsum...' },
        { id: 2, title: 'Aviso sobre o feriado da semana santa', description: '03/04/2025', imageUrl: news2, info: 'Lorem ipsum...' },
        { id: 3, title: 'Aviso sobre o feriado da semana santa', description: '03/04/2025', imageUrl: news2, info: 'Lorem ipsum...' },
        { id: 4, title: 'Aviso sobre o feriado da semana santa', description: '03/04/2025', imageUrl: news1, info: 'Lorem ipsum...' },
    ];

    const eventsInfos = [
        { id: 1, img: event1, title: 'Torneio de Judô', date: '20/06/2025', info: 'Lorem ipsum...' },
        { id: 2, img: event2, title: 'Baile Fantasia Para Sócios', date: '15/05/2025', info: 'Lorem ipsum...' },
        { id: 3, img: event3, title: 'Premiação de Sócios', date: '22/04/2025', info: 'Lorem ipsum...' },
        { id: 4, img: event4, title: 'Domingo de Páscoa da Garotada', date: '17/03/2025', info: 'Lorem ipsum...' },
    ];

    return (
        <GlobalContext.Provider value={{
            isMobile,
            isScrollingDown,
            showSecondaryHeader,
            zoomLevel,
            setZoomLevel,
            newsInfos,
            eventsInfos,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};